/**
 * ドメインの一覧（`/domains`）。名前だけを全件出す。
 *
 * 読む先は新しい表（`spec_graph_nodes`）である。名前はクラスの用語 1 語から導かれるので、
 * その用語が未設定のドメインは名前を持たない。**その行を落とさず ID で出す**
 * （`displayLabel`）。落とすと、埋めるべき行が一覧から見つけられなくなる。
 *
 * 絞り込み欄はアクター一覧と同じ理由で置かない（本番実測 3 件）。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business ドメインを名前だけで全件一覧し、マスター詳細へ繋ぐ。
 * @graph-connects useListMasters [calls] ドメイン一覧の取得
 */
import { useSearch } from '@tanstack/react-router';

import { useListMasters } from '../hooks/queries/spec-graph-element-master-queries.js';
import { toNamedNodeItems } from './element-master-list.js';
import { NamedNodeListPage } from './named-node-list.js';
import { pjTextOf } from './pj-search.js';
import { DOMAINS_ROUTE } from './route-paths.js';

/**
 * @graph-node {Function}
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business ドメインの一覧を描く。
 * @graph-connects useListMasters [calls] ドメイン一覧の取得
 * @graph-connects pjTextOf [calls] 検索条件の案件番号を文字列へ戻す
 */
export function DomainsPage() {
  const pj = pjTextOf(useSearch({ from: DOMAINS_ROUTE }).pj);
  const { data, isLoading, error } = useListMasters('domain', pj);

  return (
    <NamedNodeListPage
      nodeType="Domain"
      titleKey="domains.title"
      emptyKey="domains.empty"
      items={toNamedNodeItems(data?.items)}
      isLoading={isLoading}
      error={error}
    />
  );
}
